import { createPortal } from "react-dom";
import { usePopper }    from "react-popper";

import { MainButton } from "_components/atoms/button";
import Icon           from "_components/atoms/icon";
import PinInput       from "_components/atoms/pinInput";
import Typography     from "_components/atoms/typography";
import TVLoginPopup   from "_components/molecules/tvLoginPopup";
import useStyles      from "_styles/templates/tvLogin";

const CODE_LENGTH = 6;
const component   = ( {
	handleCodeChange,
	code,
	codeError,
	onSubmitHandler,
	isTVActivated,
	isSendingCode,
	hoverImage,
	setPopperElement,
	popperElement,
	handleHoverEnter,
	setReferenceElement,
	referenceElement,
	handleHoverExit
} ) => {
	const { classes } = useStyles ( undefined, { name: "styles" } );

	const { styles, attributes } = usePopper ( referenceElement, popperElement, {
		 placement : "right",
		modifiers : [
			{ name: "flip", enabled: false }
	  ]
	 } );

	return (

		<div
			className = { classes.content }
		>
			{
				isTVActivated ? (
					<div className = { classes.activationContainer }>
						<Icon
							className = { classes.tickIcon }
							name      = "tickFilled"
							size      = { "6rem" }
						/>

						<Typography
							className = { classes.successText }
							title     = "Activation Successful"
						/>
					</div>
				) : (
					<>
						<p className = { classes.label }>Enter code displaying on your TV</p>

						<PinInput
							containerClass = { classes.inputContainer }
							errorMsg       = { codeError }
							handleChange   = { handleCodeChange }
							numInputs      = { CODE_LENGTH }
							type           = "text"
							value          = { code }
						/>

						<MainButton
							fullWidth
							className = { classes.submitBtn }
							disabled  = { code.length !== CODE_LENGTH || isSendingCode }
							loading   = { isSendingCode }
							onClick   = { onSubmitHandler }
							title     = "Activate TV"
							variant   = "contained"
						/>

						<div
							ref          = { setReferenceElement }
							className    = { classes.helpLink }
							onMouseEnter = { handleHoverEnter }
							onMouseLeave = { handleHoverExit }
						>
							Need Help?

						</div>

						{hoverImage && createPortal (
							<div
								ref          = { setPopperElement }
								style        = { styles.popper }
								{ ...attributes.popper }
								onMouseEnter = { handleHoverEnter }
								onMouseLeave = { handleHoverExit }
							>

								<TVLoginPopup />
							</div>,
							document.querySelector ( "#tv-login-info-popup" )
						)}

					</>
				)
			}

		</div>

	);
};

export default component;